module.exports = __webpack_public_path__ + "Roboto-Thin.94998475f6aea65f5584.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/font/roboto/Roboto-Thin.ttf
// module id = ../../../../angular-bootstrap-md/font/roboto/Roboto-Thin.ttf
// module chunks = 3